// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const FolderArrowLeftOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M9 13h6m-6 0l2 2m-2-2l2-2m1.06-4.94l-.12-.12a4.28 4.28 0 00-.72-.65 2 2 0 00-.58-.23C10.4 5 10.16 5 9.67 5H6.2c-1.12 0-1.68 0-2.1.22a2 2 0 00-.88.87C3 6.52 3 7.08 3 8.2v7.6c0 1.12 0 1.68.22 2.1.19.38.5.69.87.88.43.22.99.22 2.11.22h11.6c1.12 0 1.68 0 2.1-.22a2 2 0 00.88-.87c.22-.43.22-.99.22-2.11v-5.6c0-1.12 0-1.68-.22-2.1a2 2 0 00-.87-.88C19.48 7 18.92 7 17.8 7h-3.47c-.5 0-.74 0-.97-.06a2 2 0 01-.58-.23c-.2-.13-.37-.3-.72-.65z","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","stroke":"#000"}}]},"name":"folder-arrow-left","theme":"outlined"};

const FolderArrowLeftOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={FolderArrowLeftOutlinedSvg} />;
  FolderArrowLeftOutlined.displayName = 'FolderArrowLeftOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(FolderArrowLeftOutlined);
